export default {
  aside: {
    self: {},
    items: [
      {
        clave: "dash001",
        title: "Insights",
        root: true,
        icon: "Map/Position.svg",
        page: "/dashboard",
      },
      {
        title: "organization_hub",
        root: true,
        icon: "Design/Layers.svg",
        page: "/announcements",
      },
      {
        title: "Send Alerts",
        root: true,
        admin: false,
        icon: "Communication/Archive.svg",
        page: "/push-notifications",
      },
      {
        title: "Send Check-in",
        root: true,
        icon: "Communication/Mail-opened.svg",
        page: "/polls",
        admin: false,
      },
      {
        title: "Manage Users",
        root: true,
        icon: "General/User.svg",
        page: "/users",
        submenu: [
          {
            title: "Athletes",
            page: "/users/student",
          },
          {
            title: "Staff",
            page: "/users/staff",
          },
        ],
      },
      {
        title: "Manage Teams",
        root: true,
        icon: "Communication/Group.svg",
        page: "/teams",
      },
      {
        // Zone-super-admin only — surfaces student-facing data we don't
        // expose to staff (per Janaya). Reverses the earlier TZ-786
        // Step 5 "show to all staff" decision.
        title: "Activation",
        root: true,
        icon: "Communication/Adress-book2.svg",
        page: "/activation",
        admin: true,
      },
      {
        title: "Organizations",
        root: true,
        icon: "Home/Building.svg",
        admin: true,
        page: "/schools",
      },
      {
        title: "Library",
        root: true,
        icon: "Home/Book-open.svg",
        page: "/contents",
        admin: true,
      },
      {
        title: "Zone in",
        root: true,
        icon: "Map/Direction1.svg",
        page: "/zone-in",
        admin: true,
      },
      {
        title: "Notifications",
        root: true,
        icon: "Design/Substract.svg",
        page: "/notifications",
        admin: true,
      },
      {
        title: "Playlist Management",
        root: true,
        icon: "Design/Substract.svg",
        page: "/playlist",
        admin: true,
      },
      {
        title: "Spotlight Management",
        root: true,
        icon: "Design/Substract.svg",
        page: "/spotlight",
        admin: true,
      },
      {
        title: "CS Reporting",
        root: true,
        icon: "Shopping/Chart-bar1.svg",
        page: "/cs-reporting",
        admin: true,
      },
      {
        title: "Configuration",
        root: true,
        icon: "Design/Component.svg",
        page: "/config",
        admin: true,
        submenu: [
          {
            title: "Focus Areas",
            page: "/config/focus_areas",
            admin: true,
          },
          {
            title: "Submoods",
            root: true,
            icon: "Home/Bulb1.svg",
            page: "/config/submoods",
            admin: true,
          },
          {
            title: "Staff Support topics",
            root: true,
            icon: "Communication/Call.svg",
            page: "/config/telehelp-topics",
            admin: true,
          },
          {
            title: "Tags",
            page: "/config/tags",
            admin: true,
          },
          {
            title: "Subfactors",
            page: "/config/sub-factors",
            admin: true,
          },
          {
            title: "Permissions",
            page: "/config/permissions",
            admin: true,
          },
          {
            // TZ-784: routes added in ConfigWrapper but the menu
            // links got missed when the pages shipped. Both are
            // Zone Super Admin only (gated again in ConfigWrapper
            // via user.is_admin) — keeping admin: true here for
            // consistency, the Configuration parent is already
            // admin-gated so this is belt-and-suspenders.
            title: "Master Sports",
            page: "/config/master-sports",
            admin: true,
          },
          {
            title: "Team Reconciliation",
            page: "/config/reconciliation",
            admin: true,
          },
        ],
        staff_member_admin: true,
      },
    ],
  },
};
